"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchNotificationsSagas = exports.notificationsReducers = void 0;
const redux_1 = require("redux");
const delete_1 = require("./@async/delete.js");
const get_1 = require("./@async/get.js");
const patch_1 = require("./@async/patch.js");
const remove_1 = require("./@sync/remove.js");
const remove_2 = require("./_id/@sync/remove.js");
const update_1 = require("./@sync/update.js");
const update_2 = require("./_id/@sync/update.js");
const xuder_1 = require("@sonar-software/xuder");
const _id_1 = require("./_id/index.js");
exports.notificationsReducers = (0, redux_1.combineReducers)({
    byId: _id_1.notificationsByIdReducers,
    delete: delete_1.notificationsDeleteSlice.asyncReducers,
    get: (0, xuder_1.joinCollectionReducers)([
        get_1.notificationsGetSlice.asyncReducers,
        update_1.updateNotifications.syncReducer,
        update_2.updateNotificationsById.syncReducer,
        remove_1.removeNotifications.syncReducer,
        remove_2.removeNotificationsById.syncReducer
    ], get_1.notificationsGetSlice.asyncState),
    patch: patch_1.notificationsPatchSlice.asyncReducers
});
exports.watchNotificationsSagas = (0, xuder_1.combineAllWatchers)([
    _id_1.watchNotificationsByIdSagas,
    delete_1.notificationsDeleteSlice.asyncWatchers,
    get_1.notificationsGetSlice.asyncWatchers,
    patch_1.notificationsPatchSlice.asyncWatchers
]);
//# sourceMappingURL=index.js.map